import { FormBuilder, FormGroup } from '@angular/forms';
import { getTargetGroupsIds } from '../../compliance-policies/Windows10CompliancePolicy';
import { assignmentsTargetGroups } from '../../intune-utlity';
import { getConfigurationPolicyItemSettingValueFromSchema, ConfigurationPolicySettingNames } from '../helper';
import { DeviceConfigurationWindowsChromeBlockPasswordSavingSchema } from './model';

export function initForm(
    schema: DeviceConfigurationWindowsChromeBlockPasswordSavingSchema,
    fb: FormBuilder,
): FormGroup {
    let form = new FormGroup({});
    const settingsSchema = schema.contains.properties.settings;

    form = fb.group({
        policy: fb.group({
            name: [schema.contains.properties.name.const],
            description: [schema.contains.properties.description.const],
            platform: [schema.contains.properties.platform.const],
            technologies: [schema.contains.properties.technologies.const],
        }),

        settings: fb.group({
            passwordManagerEnabled: [
                getConfigurationPolicyItemSettingValueFromSchema(
                    settingsSchema,
                    ConfigurationPolicySettingNames.chromePasswordManagerEnabled,
                ),
            ],
        }),

        assignments: fb.group({
            allUsers: [
                schema.contains.properties?.assignments?.items?.properties?.target?.oneOf?.some(
                    (res) => res?.properties?.['@odata.type']?.const === assignmentsTargetGroups.allUsers,
                ),
            ],
            allDevices: [
                schema.contains.properties?.assignments?.items?.properties?.target?.oneOf?.some(
                    (res) => res?.properties?.['@odata.type']?.const === assignmentsTargetGroups.allDevices,
                ),
            ],
            includedGroups: [getTargetGroupsIds(schema, assignmentsTargetGroups.groupInclusion)],
            groupInclusion: [
                schema.contains.properties?.assignments?.items?.properties?.target?.oneOf?.some(
                    (res) => res?.properties?.['@odata.type']?.const === assignmentsTargetGroups.groupInclusion,
                ),
            ],
        }),
    });

    return form;
}
